<template>
    <div>
        <Loading :loading="sending">
            <form ref="form" @submit.prevent="registerForNewsletter" class="relative text-blue w-full mt-4">
                <input
                    v-model="email"
                    class="w-full border-b burder-white bg-transparent p-2 placeholder:text-white text-white appearance-none rounded-none"
                    :class="innerClass"
                    :placeholder="placeholder"
                    type="email"
                    name="email"
                />
                <Icon
                    @click="registerForNewsletter()"
                    type="ArrowRight"
                    viewBox="0 0 29 21"
                    width="29"
                    height="21"
                    class="fill-none stroke-current absolute pr-1 right-0 top-2 cursor-pointer"
                />
            </form>
            <TransitionExpand v-show="email">
                <div class="mt-2 link text-xxs" v-html="$t('read_and_accept_privacy_policy')"></div>
            </TransitionExpand>
        </Loading>
    </div>
</template>

<script>
import api from '../../api';
import { getActiveLanguage } from 'laravel-vue-i18n';

export default {
    data: () => ({
        email: null,
        sending: false
    }),
    props: ['innerClass', 'redirect', 'placeholder'],
    methods: {
        registerForNewsletter() {
            if (this.sending === false) {
                this.sending = true;
                api.post(`/api/v1/newsletters/subscribe`, {
                    email: this.email,
                    language: getActiveLanguage()
                })
                    .then((response) => {
                        if (this.redirect) {
                            this.$router.push({
                                path: this.redirect
                            });
                        }
                        this.loading = false;
                        this.email = null;
                        this.sending = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.sending = false;
                        this.$toast.error(error.response.data.errors.email[0]);
                    });
            }
        }
    }
};
</script>
